import AsyncStorage from '@react-native-async-storage/async-storage';

export type PendingIntentParams = Record<string, string | number | undefined>;

export type PendingNavigationIntent =
  | {
      kind: 'route';
      pathname: string;
      params?: PendingIntentParams;
    }
  | {
      kind: 'invite';
      linkId: string;
    };

let pendingNavigationIntent: PendingNavigationIntent | null = null;
const STORAGE_KEY = '@tripvio_pending_navigation_intent_v1';
let hydrationStarted = false;

const persistIntent = async (intent: PendingNavigationIntent | null) => {
  try {
    if (!intent) {
      await AsyncStorage.removeItem(STORAGE_KEY);
      return;
    }
    await AsyncStorage.setItem(STORAGE_KEY, JSON.stringify(intent));
  } catch {
    // best-effort persistence only
  }
};

const hydrateIntent = async () => {
  if (hydrationStarted) return;
  hydrationStarted = true;
  try {
    const raw = await AsyncStorage.getItem(STORAGE_KEY);
    if (!raw) return;
    const parsed = JSON.parse(raw) as PendingNavigationIntent | null;
    if (!parsed || typeof parsed !== 'object') return;
    pendingNavigationIntent = parsed;
  } catch {
    // ignore stale cache parse errors
  }
};

void hydrateIntent();

export function setPendingNavigationIntent(intent: PendingNavigationIntent | null): void {
  pendingNavigationIntent = intent;
  void persistIntent(intent);
}

export function getPendingNavigationIntent(): PendingNavigationIntent | null {
  return pendingNavigationIntent;
}

export function consumePendingNavigationIntent(): PendingNavigationIntent | null {
  const intent = pendingNavigationIntent;
  pendingNavigationIntent = null;
  void persistIntent(null);
  return intent;
}

export function toPendingIntentParams(
  source: Record<string, string | string[] | number | undefined>,
): PendingIntentParams | undefined {
  const entries = Object.entries(source).flatMap(([key, value]) => {
    if (value === undefined) return [];
    if (Array.isArray(value)) {
      const first = value[0];
      if (first === undefined) return [];
      return [[key, first] as const];
    }
    return [[key, value] as const];
  });
  if (entries.length === 0) return undefined;
  return Object.fromEntries(entries);
}
